import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    color: theme.palette.text.secondary,
    fontSize: 14,
    border: `1px solid ${theme.palette.text.hint}`,
    padding: "2px 14px",
    borderRadius: 3,
    transition: "all .2s",
    minHeight: 30
  },
  buttonActive: {
    color: "#489b77",
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main
    }
  },
  buttonRoot: {
    [theme.breakpoints.down("xs")]: {
      width: 44,
      minWidth: 44
    }
  },
  buttonText: {
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  icon: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("xs")]: {
      margin: 0
    }
  },
  iconActive: {
    color: "#489b77"
  },
  paper: {
    marginTop: 8
  },
  rootPopover: {
    width: 324,
    padding: "24px 20px"
  }
}));
